var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Pagination", attrs: { id: "Pagination" } },
    [
      _c("el-pagination", {
        staticClass: "page-box",
        attrs: {
          background: "",
          "current-page": _vm.childMsg.currentPage,
          "page-sizes": _vm.pageSizes,
          "page-size": _vm.childMsg.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.childMsg.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }